<template>
  <div class="category-chips tw-w-full">
    <p class="category-chips__label tw-mb-2 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500">
      {{ $l('categories') }}
    </p>
    <div class="category-chips__track" role="list">
      <router-link
        v-for="category in categoriesWithSlug"
        :key="category.slug"
        :to="`/compare/${category.slug}`"
        role="listitem"
        class="category-chip tw-pressable"
      >
        {{ $l(category.labelKey) }}
      </router-link>
      <button
        v-for="category in categoriesWithoutSlug"
        :key="category.search"
        type="button"
        role="listitem"
        class="category-chip tw-pressable"
        @click="$emit('category-selected', category.search)"
      >
        {{ $l(category.labelKey) }}
      </button>
      <router-link
        to="/compare"
        role="listitem"
        class="category-chip category-chip--all tw-pressable"
      >
        {{ $l('allCategories') }}
        <span aria-hidden="true">→</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { CATEGORY_CHIP_SLUGS } from '@/seo/comparePages';

const CATEGORIES = [
  { labelKey: 'catHomeDecor', search: 'Home Decor', slug: CATEGORY_CHIP_SLUGS.catHomeDecor },
  { labelKey: 'catBluetoothSpeakers', search: 'Bluetooth Speakers', slug: CATEGORY_CHIP_SLUGS.catBluetoothSpeakers },
  { labelKey: 'catSmartphones', search: 'Smartphones', slug: CATEGORY_CHIP_SLUGS.catSmartphones },
  { labelKey: 'catPetsSupplies', search: 'Pets Supplies' },
  { labelKey: 'catElectronics', search: 'Electronics' },
  { labelKey: 'catDiy', search: 'Do it yourself' },
  { labelKey: 'catFashionAccessories', search: 'Fashion Accessories' },
  { labelKey: 'catKidsToys', search: 'Kids Toys', slug: CATEGORY_CHIP_SLUGS.catKidsToys },
];

export default {
  name: 'CategoryChips',
  data() {
    return {
      categories: CATEGORIES,
    };
  },
  computed: {
    categoriesWithSlug() {
      return this.categories.filter((category) => category.slug);
    },
    categoriesWithoutSlug() {
      return this.categories.filter((category) => !category.slug);
    },
  },
};
</script>

<style scoped>
.category-chips__track {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.category-chips__track::-webkit-scrollbar {
  display: none;
}

.category-chip {
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.78);
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.44);
  backdrop-filter: blur(44px) saturate(165%);
  -webkit-backdrop-filter: blur(44px) saturate(165%);
  box-shadow:
    0 4px 20px rgba(139, 124, 246, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  padding: 0.5rem 0.875rem;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.2;
  color: #334155;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.category-chip:hover {
  border-color: #93c5fd;
  box-shadow:
    0 6px 24px rgba(37, 99, 235, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.category-chip:active {
  transform: scale(0.97);
}

.category-chip--all {
  border-color: rgba(37, 99, 235, 0.35);
  background: rgba(239, 246, 255, 0.72);
  color: #1d4ed8;
}

.category-chip--all:hover {
  border-color: #2563eb;
  background: rgba(219, 234, 254, 0.9);
  color: #1e40af;
}

@media (min-width: 1024px) {
  .category-chips__track {
    flex-wrap: wrap;
    overflow-x: visible;
  }

  .category-chip {
    background: #fff;
    border-color: #e2e8f0;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  }

  .category-chip--all {
    border-color: #bfdbfe;
    background: #eff6ff;
    color: #1d4ed8;
  }
}
</style>
